import React, { Component } from "react";
import { Paper, Grid, Typography } from "@material-ui/core";
import { connect } from "react-redux";
import MapContainer from "./MapContainer";
import { getJobPacks, redirectTo } from "./actions";
import moment from "moment";
import { hot } from "react-hot-loader";
class JobPackMapWidget extends Component {
    constructor(props) {
        super(props);
        let year = moment().format("YYYY");

        let month = moment().format("MMM").toLowerCase();
        props.getJobPacks("active", year, month);

        this.state = {
            status: "active",
            year,
            month,
        };
    }
    componentDidUpdate(nextProps, nextState) {}
    render() {
        const { sm, md, lg, jobpacks, mapKey } = this.props;

        const { year, month, status } = this.state;
        return (
            <Grid item sm={sm} md={md} lg={lg}>
                <Paper
                    style={{
                        borderRadius: 0,
                        position: "relative",
                        overflow: "hidden",
                        height: "450px",
                    }}
                >
                    <Typography variant="h6" style={{ padding: 24 }}>
                        Active Jobpacks ({moment().format("MMMM")})
                    </Typography>

                    {
                        <div
                            style={{
                                position: "relative",
                                width: "100%",
                                height: "80%",
                            }}
                        >
                            <MapContainer
                                style={{
                                    width: "100%",
                                    height: "100%",
                                }}
                                jobList={jobpacks}
                                redirect={this.props.redirectTo}
                                st={status}
                                year={year}
                                month={month}
                                mapKey={mapKey}
                            />
                        </div>
                    }
                </Paper>
            </Grid>
        );
    }
}

export default hot(module)(
    connect(
        (store, props) => {
            const { selectors } = props;
            const { selectJobPacks } = selectors;

            return {
                jobpacks: selectJobPacks(store),
            };
        },
        { getJobPacks, redirectTo }
    )(JobPackMapWidget)
);
